import { render, staticRenderFns } from "./SamsungUpdateView.vue?vue&type=template&id=32168194&scoped=true&"
import script from "./SamsungUpdateView.vue?vue&type=script&lang=js&"
export * from "./SamsungUpdateView.vue?vue&type=script&lang=js&"
import style0 from "./SamsungUpdateView.vue?vue&type=style&index=0&id=32168194&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32168194",
  null
  
)

export default component.exports